// extracted by mini-css-extract-plugin
export default {"header":"InformationSection_header__BnLyD","title":"InformationSection_title__t9QB5","content--padded":"InformationSection_content--padded__QlGsl"};